import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
}

const CompanyName = ({ helper, ...rest }: Props) => {
  const name = 'company_name'
  const label = 'Company name'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default CompanyName
